import { amplitudeLogEvent } from 'client-analytics/amplitude';

import { Checkbox as CheckboxToggle } from 'components/toggle-switch';
import Message from 'components/message';
import { BadgeBeta } from 'components/badges/badge-beta';
import { T } from 'components/translation';

import { useImportContractContext } from 'contexts/import-contract-props';

import {
  isAiImport,
  isStandardImport,
} from '../utils';
import { AI, STANDARD } from '../constants';

import style from './import-method-toggle.module.scss';

export const ImportMethodToggle = () => {
  const {
    importMethod,
    setImportMethod,
    resetExtractionState,
  } = useImportContractContext();
  return (
    <div className={style.ToggleContainer}>
      <CheckboxToggle
        input={{
          name: 'importMethodToggle',
          checked: isAiImport(importMethod),
          onChange: () => {
            setImportMethod(isStandardImport(importMethod) ? AI : STANDARD);
            resetExtractionState();
            amplitudeLogEvent('Temp Toggle Import Type');
          },
        }}
        valueLabels={[
          <Message key="manual" id="Manual" comment="Adjective, showed in a modal where user can choose a way to import a contract" />,
          'AI Extract',
        ]}
        rightLabelClass={style.ToggleLabel}
        leftLabelClass={style.ToggleLabel}
        toggleSwitchClass={style.ToggleSwitch}
      />
      {isStandardImport(importMethod)
        ? (
          <T
            _str="Manually add duration and participants."
            _comment="Helper text to make it clear for the user what the import is about."
          />
        ) : (
          <div className={style.AiImportLabel}>
            <BadgeBeta />
            <T
              _str="Automatically extract duration and participants."
              _comment="Helper text to make it clear for the user what the import is about."
            />
          </div>
        )}
    </div>
  );
};
